export default __webpack_public_path__ + "static/media/BestRest-HTML-Markup.0fd30392.jpg";